// extracted by mini-css-extract-plugin
export default {"MuteAndKeypadButtons":"buttonsCalling_MuteAndKeypadButtons__pd-jS"};